var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityReception = function SvgFacilityReception(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40-442v-394h215v57l311-89 314 96v137H668v73L349-442zm60-60h94v-274h-94zm155 0h84l265-101v-32h-77l-115 38-22-58 129-40h299v-33l-256-78-307 90zM400-80h520v-60H400zm40-120h440q0-81-51.5-141.5T700-415.823V-480h-80v64.177Q542-402 491-341.5T440-200m71-60q18-44 58-72t91.211-28Q710-360 750-332t58 72zm149 0"
  })));
};
export default SvgFacilityReception;